import { toast } from "react-toastify";
import api from "../../../../../../features/auth/axiosConfig";
import { postCustomer } from "src/shared/services/services";

export const useCustomerActions = (
  setCustomerName: (v: string) => void,
  setPhoneNumber: (v: string) => void,
  setTableNumber: (v: string) => void,
  setCustomerAdd: (v: boolean) => void
) => {
  /** 🔹 Close/reset customer modal */
  const handleCloseCustomer = () => {
    setCustomerAdd(false);
    setCustomerName("");
    setPhoneNumber("");
    setTableNumber("");
  };

  /** 🔹 Create a new customer */
  const createCustomer = async (name: string, phone: string, table: string) => {
    try {
      const res = await api.post("/app/v1/pos/customer", {
        Name: name,
        phone_number: phone,
        // table_number: table,
      });
      return res.data._id;
    } catch (err: any) {
      if (err?.response?.data?.message === "Phone number already exists.") {
        toast.error("Phone number already exists.");
      } else {
        toast.error("Error creating customer");
      }
      return null;
    }
  };

  /** 🔹 Create or fetch Unknown (Walk-in) Customer */
  const createUnknownCustomer = async () => {
    const UNKNOWN_PHONE = "0000000000";
    const UNKNOWN_NAME = "XXXX";

    try {
      // 1️⃣ Check if unknown customer already exists
      const res = await api.get(
        `/app/v1/pos/customer?searchBy=${UNKNOWN_PHONE}&pageNumber=1&pageSize=1`
      );

      const existingCustomer = res.data?.customer_details?.[0];
      if (existingCustomer) {
        return existingCustomer._id?.$oid || existingCustomer._id;
      }

      // 2️⃣ Create new unknown customer
      const payload = {
        Name: UNKNOWN_NAME,
        phone_number: UNKNOWN_PHONE,
      };

      const createRes = await postCustomer(payload);
      return createRes.data?._id?.$oid || createRes.data?._id;
    } catch (error) {
      console.error("Failed to create/fetch unknown customer", error);
      return null;
    }
  };

  return {
    handleCloseCustomer,
    createCustomer,
    createUnknownCustomer, // ✅ Exported via returned object
  };
};
